<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="标题" label-width="80px">
        <el-input v-model="queryParam.title" clearable></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>脚本库</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container" v-if="$permission.hasAuth([4, 8, 12])">
            <el-button type="success" @click="showSave()">
              <el-icon><plus /></el-icon>新增脚本
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="scripts" border>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="cover" label="封面"></el-table-column>
      <el-table-column prop="scene" label="场景"></el-table-column>
      <el-table-column label="话术">
        <template #default="scope">
          <el-popover placement="bottom-start" :width="260" trigger="hover"
              title="话术" :content="scope.row.content">
            <template #reference>
              <el-link href="javascript:;" type="primary">{{scope.row.content.substr(0, 15) + '...'}}</el-link>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="样片">
        <template #default="scope">
          <el-link href="javascript:;" type="primary" v-if="scope.row.videoLink" @click="showVideo(scope.row.videoLink)">预览</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="copy(scope.row)">复制</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8, 12])" @click="showSave(scope.row)">修改</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([10])" @click="showPublish(scope.row)">发布</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="!script.sn ? '新增脚本' : '修改脚本'" v-model="saveVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="script" ref="script">
      <el-form-item label="标题" label-width="78px">
        <el-input v-model="script.title" clearable></el-input>
      </el-form-item>
      <el-form-item label="封面" label-width="78px">
        <el-input v-model="script.cover" clearable></el-input>
      </el-form-item>
      <el-form-item label="场景" label-width="78px">
        <el-input v-model="script.scene" clearable></el-input>
      </el-form-item>
      <el-form-item label="话术" label-width="78px">
        <el-input v-model="script.content" type="textarea" :rows="5" clearable></el-input>
      </el-form-item>
      <el-form-item label="样片" label-width="78px">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/video'" :show-file-list="false"
                   :on-success="handleSuccess" :on-progress="handleProgress" :before-upload="beforeUpload">
          <el-icon class="loading" v-if="processVisible"><loading /></el-icon>
          <video v-if="script.videoLink" :src="$utils.imageSrc(script.videoLink)" controls></video>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item label="是否公开" label-width="78px">
        <el-radio v-model="script.status" :label="true">公开</el-radio>
        <el-radio v-model="script.status" :label="false">不公开</el-radio>
      </el-form-item>
      <el-button type="primary" @click="save">确定</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="发布任务" v-model="publishVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form inline>
      <el-form-item label="发布时间" label-width="78px">
        <el-date-picker v-model="publish.publishDate" :editable="false" :clearable="false" placeholder="请选择日期"
                        type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" @change="refreshShop"/>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="publishScript">确认发布</el-button>
      </el-form-item>
    </el-form>
    <el-empty v-if="!publish.publishDate" :image-size="64" description="请选择发布日期" />
    <el-tabs v-else v-model="publish.qqName" @tab-click="handleTabChange" tab-position="left" style="height: 200px">
      <el-tab-pane v-for="(item, index) in groups" :key="index" :label="item.qqName" :name="item.qqName">
        <el-table ref="table" :data="item.factoryVOS" @selection-change="handleSelectionChange" border>
          <el-table-column type="selection" :selectable="handleSelectable"></el-table-column>
          <el-table-column prop="factoryCompany" label="门店名称"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column label="状态">
            <template #default="scope">
              <el-tag :type="scope.row.status ? 'success' : 'info'">{{scope.row.status ? '已发布' : '未发布'}}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>

  <div class="video_container" v-if="videoVisible">
    <div class="mask"></div>
    <el-icon class="close_btn" @click="closeVideo"><circle-close /></el-icon>
    <video :src="videoSrc" controls autoplay></video>
  </div>
</template>

<script>
import clipboard from 'vue-clipboard3'

export default {
  name: "脚本库管理",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      scripts: [],
      saveVisible: false,
      script: {},
      publishVisible: false,
      publish: {},
      groups: [],
      checkedShops: [],
      videoVisible: false,
      videoSrc: null,
      processVisible: false
    }
  },
  methods: {
    beforeUpload(file) {
      const isVideo = file.type === 'video/mpeg4' || file.type === 'video/mp4'
      const isLes50M = file.size / 1024 / 1024 < 50
      if (!isVideo) {
        this.$message.error('视频只能是 MP4 格式!')
      }
      if (!isLes50M) {
        this.$message.error('视频大小不能超过 50MB!')
      }
      return isVideo && isLes50M
    },
    handleSuccess(res, file) {
      console.log('上传成功')
      this.processVisible = false
      this.script.videoLink = res.data
    },
    handleProgress(res) {
      if (!this.processVisible) {
        this.processVisible = true
      }
      console.log('上传中', res)
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.queryParam.pageIndex = this.pageIndex - 1
      this.queryParam.pageSize = this.pageSize
      this.$apis.operationScript.list(this.queryParam).then(response => {
        this.scripts = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showSave(script) {
      this.saveVisible = true
      if (script) {
        Object.assign(this.script, script)
      } else {
        this.script = {
          status: true
        }
      }
    },
    save() {
      if (!this.script.title) {
        this.$message.error('请输入标题')
        return
      }
      if (!this.script.cover) {
        this.$message.error('请输入封面')
        return
      }
      if (!this.script.scene) {
        this.$message.error('请输入场景')
        return
      }
      if (!this.script.content) {
        this.$message.error('请输入话术')
        return
      }
      if (!this.script.sn) {
        this.$apis.operationScript.add(this.script).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.operationScript.edit(this.script).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveVisible = false
            this.list()
          }
        })
      }
    },
    showPublish(script) {
      this.publishVisible = true
      this.publish = {
        douyinScriptSns: [script.sn],
        generalServiceSn: this.currentUser.sn,
        publishDate: null
      }
      this.groups = []
    },
    handleTabChange() {
      this.checkedShops = []
      this.$refs.table.forEach(item => item.clearSelection())
    },
    refreshShop() {
      const param = {
        date: this.publish.publishDate,
        generalServiceSn: this.currentUser.sn
      }
      this.$apis.operationScript.shops(param).then(response => {
        this.publish.qqName = response.data[0].qqName
        this.groups = response.data
      })
    },
    handleSelectionChange(val) {
      this.checkedShops = val
    },
    handleSelectable(row) {
      return !row.status
    },
    publishScript() {
      if (!this.checkedShops || this.checkedShops.length <= 0) {
        this.$message.error('请选择门店')
        return
      }
      this.publish.factorySns = this.checkedShops.map(item => item.factorySn)
      this.$apis.operationScript.publish(this.publish).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '发布成功',
            type: 'success'
          })
          this.refreshShop()
        }
      })
    },
    copy(script) {
      const text = '标题：' + script.title
          + '\n封面：' + script.cover
          + '\n场景：' + script.scene
          + '\n话术：' + script.content
      clipboard().toClipboard(text)
      this.$message({
        message: '已复制',
        type: 'success'
      })
    },
    showVideo(src) {
      this.videoVisible = true
      this.videoSrc = this.$utils.imageSrc(src)
    },
    closeVideo() {
      this.videoVisible = false
    }
  },
  created() {
    this.list()
  }
}
</script>

<style scoped>
.loading {
  position: absolute;
  top: 26px;
  left: 61px;
  font-size: 88px;
  color: #909399;
  z-index: 200;
  -webkit-animation: loadingRotate 3s linear infinite;
  animation: loadingRotate 3s linear infinite;
}

@-webkit-keyframes loadingRotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes loadingRotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>